module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    class: {
      'side-tab-view': _vm.sideTabView,
      onMobile: _vm.onMobile
    }
  }, [_c('div', {
    staticClass: "box__content",
    class: {
      'cursor-pointer': !_vm.hoverOverlay
    },
    on: {
      "click": function($event) {
        !_vm.hoverOverlay && _vm.currentUser != null ? _vm.$router.push(("/video/" + (_vm.item.id) + "/show")) : _vm.fetchSpotlightVideo()
      }
    }
  }, [(_vm.durationTag && !_vm.coverOnly) ? _c('span', {
    staticClass: "duration__tag"
  }, [_vm._v(_vm._s(_vm.durationTag))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box__image",
    class: {
      coverRadius: _vm.coverRadius
    },
    style: (("background-image: url(" + (_vm._.get(_vm.item, 'cover.url')) + ")"))
  }, [(_vm.showFullOverlay) ? _c('div', {
    staticClass: "full-overlay"
  }, [_c('v-icon', {
    staticClass: "full-overlay_icon icon play-button-2 iconHasWhiteBG black--text"
  }, [_vm._v("play_arrow")]), _vm._v(" "), _c('div', {
    staticClass: "hover-info"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "artist-name"
  }, [_vm._v(_vm._s(_vm.item.user.username))])])], 1) : _vm._e()]), _vm._v(" "), (_vm.isLive) ? _c('div', {
    staticClass: "box__caption"
  }, [_vm._v("Live")]) : _vm._e(), _vm._v(" "), (_vm.hoverOverlay) ? _c('div', {
    staticClass: "box__overlay"
  }, [_c('v-btn', {
    staticClass: "box__cta",
    attrs: {
      "block": "",
      "dark": "",
      "to": ("/video/" + (_vm.item.id) + "/show")
    }
  }, [_vm._v("Watch Now")])], 1) : _vm._e()]), _vm._v(" "), (!_vm.coverOnly) ? _c('div', {
    staticClass: "box__footer dflex align-start",
    class: {
      'px-2': _vm.onMobile
    }
  }, [(!_vm.hideUser) ? _c('user-tag', {
    attrs: {
      "showAvatar": "",
      "hideName": "",
      "hideTick": "",
      "width": "40",
      "height": "40",
      "user": _vm.item.user
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box_subtitle-wrapper",
    class: {
      'dgrid': _vm.sideTabView
    }
  }, [_c('div', {
    staticClass: "box__subtitle"
  }, [(_vm.item.accounts.length > 0) ? _c('span', {
    staticClass: "box__acc-wrapper"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "stream_name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), (_vm.showUsername) ? _c('div', {
    staticClass: "user_name"
  }, [_c('b', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.item.user.username))])]) : _vm._e()]), _vm._v(" "), (!_vm.noMeta) ? _c('div', {
    staticClass: "box__title"
  }, [_c('div', {
    staticClass: "box__author"
  }), _vm._v(" "), _c('div', {
    staticClass: "box__views__duration_wrapper dflex align-center"
  }, [(_vm.showViews) ? _c('span', {
    staticClass: "box__views mr-2"
  }, [_vm._v("0 views")]) : _vm._e(), _vm._v(" "), (!_vm.hideFreeTag && _vm.isVideoFree && !_vm.sideTabView) ? _c('span', {
    staticClass: "user-name"
  }, [_vm._v("\n            " + _vm._s(_vm.item.user.username) + "\n          ")]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.altMeta) ? _c('div', {
    staticClass: "mt-2 box__footer alt-meta",
    class: {
      'px-2': _vm.onMobile
    }
  }, [_c('div', {
    staticClass: "alt-meta-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "alt-meta-user"
  }, [_c('b', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.item.user.username))])])]) : _vm._e(), _vm._v(" "), (_vm.forCollection || _vm.playlistId) ? _c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 100
    }
  }, [_c('v-btn', {
    staticClass: "toolbar-btn",
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.is_menu_hover = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-card', [_c('v-list', [_c('v-list-tile', {
    key: "remove",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openRemoveFromCollectionModal()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center"
  }, [_c('label', {
    staticClass: "ml-0 black--text"
  }, [_vm._v("Remove")])])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard1),
      callback: function($$v) {
        _vm.show_modalCard1 = $$v
      },
      expression: "show_modalCard1"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + _vm.item.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(_vm.item.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n            Create account\n          ")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard2),
      callback: function($$v) {
        _vm.show_modalCard2 = $$v
      },
      expression: "show_modalCard2"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + _vm.item.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(_vm.item.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n            Start 30 day free trial\n          ")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard3),
      callback: function($$v) {
        _vm.show_modalCard3 = $$v
      },
      expression: "show_modalCard3"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + _vm.item.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(_vm.item.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n              Create account\n            ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mute-icon.svg"),
      "width": "17px"
    }
  })])])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard4),
      callback: function($$v) {
        _vm.show_modalCard4 = $$v
      },
      expression: "show_modalCard4"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + _vm.item.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(_vm.item.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n              Start 30 day free trial\n            ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mute-icon.svg"),
      "width": "17px"
    }
  })])])])]), _vm._v(" "), (_vm.forCollection) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_remove_from_collection_modal),
      callback: function($$v) {
        _vm.show_remove_from_collection_modal = $$v
      },
      expression: "show_remove_from_collection_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Remove from Collection\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to remove video from collection?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeFromCollection()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1) : (_vm.playlistId) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_remove_from_collection_modal),
      callback: function($$v) {
        _vm.show_remove_from_collection_modal = $$v
      },
      expression: "show_remove_from_collection_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Remove from Playlist\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to remove this video from playlist?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeFromPlaylist('stream', _vm.item.id, _vm.playlistId);
        _vm.show_remove_from_collection_modal = false
      }
    }
  }, [_vm._v("\n          Yes\n        ")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fd409f8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/video_box.vue
// module id = 1692
// module chunks = 180